import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarLeftArrow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSidebarLeftArrow"><Path d="M7 3H3V21H7V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M9 21H21V3H9V21ZM17.4142 10L15.4142 12L17.4142 14L16 15.4142L12.5858 12L16 8.58579L17.4142 10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarLeftArrow;
